module.exports = __webpack_public_path__ + "static/headerlogo.3d76eeab.svg";